module.exports = __webpack_public_path__ + "img/author-4@2x.8f387a7.jpg";